export interface Course {
  id: string;
  title: string;
  slug: string;
  description: string;
  shortDescription: string;
  category: string;
  categorySlug: string;
  zone: '一区' | '二区';
  zoneLabel: string;
  imageSeq: string;
  author: string;
  date: string;
  readTime: string;
  rating: number;
  students: number;
  price: string;
  level: string;
  tags: string[];
  content: string;
  featured: boolean;
}

export const courses: Course[] = [
  {
    id: 'jp-lang-001',
    title: '日语零基础到N3系统精讲',
    slug: 'jp-lang-001',
    description: '从五十音图开始，系统掌握日语基础知识，达到日语能力考试N3水平。课程涵盖词汇、语法、听力、阅读四大模块，配合大量练习和模拟测试，帮助成人学习者高效入门日语。',
    shortDescription: '从五十音到N3，系统构建日语基础能力',
    category: '语言课程',
    categorySlug: 'language',
    zone: '一区',
    zoneLabel: '日本区',
    imageSeq: 'jp-lang-001',
    author: '田中真由美',
    date: '2026-07-15',
    readTime: '48课时',
    rating: 4.8,
    students: 3256,
    price: '¥1,299',
    level: '初级',
    tags: ['日语入门', 'N3考试', '零基础', '系统学习'],
    featured: true,
    content: `## 课程概述

本课程专为零基础成人学习者设计，从日语最基础的五十音图开始，循序渐进地带领学员掌握日语核心知识体系。课程内容严格对标日本语能力测试（JLPT）N3级别要求，帮助学员在系统学习后具备基本的日常交流能力和阅读能力。

## 适合人群

- 完全零基础的日语学习者
- 希望系统学习日语基础知识的成人
- 准备参加JLPT N3考试的考生
- 对日本文化感兴趣、想深入学习日语的朋友

## 课程大纲

### 第一阶段：语音基础（6课时）
- 五十音图：平假名与片假名的书写与发音
- 日语发音规则：长音、促音、拗音
- 基础语调与节奏训练

### 第二阶段：初级语法与词汇（18课时）
- 名词句、形容词句、动词句的基本结构
- 敬语基础：丁寧語的使用场景
- 基础助词：は、が、を、に、で、へ
- 核心词汇1200词

### 第三阶段：中级语法与表达（18课时）
- 条件表达：と、ば、たら、なら
- 授受关系：あげる、くれる、もらう
- 使役态、被动态、使役被动态
- 敬语体系：尊敬語、謙譲語

### 第四阶段：N3综合提升（6课时）
- N3真题解析与技巧
- 听力专项训练
- 阅读速度提升
- 模拟考试与讲评

## 学习收获

完成本课程后，您将能够：
- 掌握约3000个日语词汇
- 理解并运用N3级别语法
- 进行日常场景下的日语交流
- 阅读简单的日语文章和新闻
- 具备参加JLPT N3考试的能力`,
  },
  {
    id: 'jp-career-001',
    title: '日本职场商务日语与礼仪',
    slug: 'jp-career-001',
    description: '面向计划赴日工作或已在日企工作的成人学习者，系统教授商务日语表达、日本职场礼仪、邮件写作、会议沟通等实战技能，帮助学员快速适应日本职场环境。',
    shortDescription: '掌握商务日语，从容应对日本职场',
    category: '职场培训',
    categorySlug: 'career',
    zone: '一区',
    zoneLabel: '日本区',
    imageSeq: 'jp-career-001',
    author: '山本健一',
    date: '2026-07-10',
    readTime: '36课时',
    rating: 4.9,
    students: 2189,
    price: '¥1,599',
    level: '中级',
    tags: ['商务日语', '职场礼仪', '日企文化', '邮件写作'],
    featured: true,
    content: '',
  },
  {
    id: 'jp-culture-001',
    title: '日本传统文化深度赏析',
    slug: 'jp-culture-001',
    description: '从茶道、花道、书道到和食文化，深入探索日本传统美学与生活哲学。课程结合理论讲解与实践体验，帮助学习者理解日本文化的精髓。',
    shortDescription: '探索茶道花道书道，感受日本美学精髓',
    category: '文化教育',
    categorySlug: 'culture',
    zone: '一区',
    zoneLabel: '日本区',
    imageSeq: 'jp-culture-001',
    author: '小林樱子',
    date: '2026-06-28',
    readTime: '32课时',
    rating: 4.7,
    students: 1567,
    price: '¥899',
    level: '不限',
    tags: ['茶道', '花道', '书道', '和食', '传统文化'],
    featured: true,
    content: '',
  },
  {
    id: 'kr-lang-001',
    title: '韩语入门到TOPIK II通关',
    slug: 'kr-lang-001',
    description: '从韩文字母（한글）开始，系统学习韩语发音、语法和表达，目标达到韩国语能力考试TOPIK II 3-4级水平。课程结合K-pop、韩剧等流行文化素材，让学习更有趣。',
    shortDescription: '从한글到TOPIK II，趣味学韩语',
    category: '语言课程',
    categorySlug: 'language',
    zone: '二区',
    zoneLabel: '韩国区',
    imageSeq: 'kr-lang-001',
    author: '朴智恩',
    date: '2026-07-18',
    readTime: '52课时',
    rating: 4.9,
    students: 4120,
    price: '¥1,399',
    level: '初级',
    tags: ['韩语入门', 'TOPIK', 'K-pop', '韩剧', '系统学习'],
    featured: true,
    content: '',
  },
  {
    id: 'kr-career-001',
    title: '韩国职场韩语与企业文化',
    slug: 'kr-career-001',
    description: '针对韩国企业的职场韩语培训课程，涵盖面试韩语、商务邮件、会议表达、韩国企业组织文化等内容，帮助学员快速融入韩国职场。',
    shortDescription: '掌握职场韩语，决胜韩国企业面试',
    category: '职场培训',
    categorySlug: 'career',
    zone: '二区',
    zoneLabel: '韩国区',
    imageSeq: 'kr-career-001',
    author: '李在镕',
    date: '2026-07-05',
    readTime: '40课时',
    rating: 4.7,
    students: 1892,
    price: '¥1,499',
    level: '中级',
    tags: ['职场韩语', '韩国企业', '面试技巧', '商务礼仪'],
    featured: true,
    content: '',
  },
  {
    id: 'kr-culture-001',
    title: '韩国流行文化与现代社会',
    slug: 'kr-culture-001',
    description: '以K-pop、K-drama、韩国电影、时尚美妆为切入点，深入剖析韩国现代文化现象背后的社会变迁与价值观念。适合对韩国流行文化感兴趣的成人学习者。',
    shortDescription: '透过K-pop与韩剧，读懂韩国现代社会',
    category: '文化教育',
    categorySlug: 'culture',
    zone: '二区',
    zoneLabel: '韩国区',
    imageSeq: 'kr-culture-001',
    author: '金秀雅',
    date: '2026-06-20',
    readTime: '24课时',
    rating: 4.8,
    students: 2987,
    price: '¥799',
    level: '不限',
    tags: ['K-pop', '韩剧', '韩国电影', '时尚', '社会文化'],
    featured: false,
    content: '',
  },
  {
    id: 'jp-degree-001',
    title: '日本大学院留学申请全程指导',
    slug: 'jp-degree-001',
    description: '为计划赴日攻读硕士或博士学位的成人学习者提供全方位申请指导，包括研究计划书撰写、教授联系技巧、面试准备、奖学金申请等关键环节。',
    shortDescription: '全程指导日本大学院申请，圆你留学梦',
    category: '学历提升',
    categorySlug: 'degree',
    zone: '一区',
    zoneLabel: '日本区',
    imageSeq: 'jp-degree-001',
    author: '佐藤优子',
    date: '2026-07-22',
    readTime: '30课时',
    rating: 4.6,
    students: 987,
    price: '¥2,199',
    level: '高级',
    tags: ['留学申请', '研究计划书', '奖学金', '大学院'],
    featured: false,
    content: '',
  },
  {
    id: 'kr-degree-001',
    title: '韩国名校本科申请攻略',
    slug: 'kr-degree-001',
    description: '全面介绍韩国SKY等名校的本科申请流程，包括语言要求、材料准备、面试技巧、奖学金政策等，帮助学员规划最优申请路径。',
    shortDescription: '韩国名校申请全攻略，SKY不是梦',
    category: '学历提升',
    categorySlug: 'degree',
    zone: '二区',
    zoneLabel: '韩国区',
    imageSeq: 'kr-degree-001',
    author: '崔敏浩',
    date: '2026-07-08',
    readTime: '28课时',
    rating: 4.5,
    students: 756,
    price: '¥1,899',
    level: '中级',
    tags: ['韩国留学', 'SKY名校', '本科申请', '奖学金'],
    featured: false,
    content: '',
  },
  {
    id: 'jp-exam-001',
    title: 'JLPT N1/N2考前冲刺特训',
    slug: 'jp-exam-001',
    description: '针对JLPT N1和N2级别的高强度考前冲刺课程，精准覆盖高频考点，提供大量真题训练和模拟考试，帮助学员在短期内实现分数突破。',
    shortDescription: 'N1/N2考前冲刺，精准突破高分',
    category: '资格考试',
    categorySlug: 'exam',
    zone: '一区',
    zoneLabel: '日本区',
    imageSeq: 'jp-exam-001',
    author: '渡边诚',
    date: '2026-07-01',
    readTime: '24课时',
    rating: 4.8,
    students: 1432,
    price: '¥1,099',
    level: '高级',
    tags: ['JLPT', 'N1考试', 'N2考试', '考前冲刺', '真题'],
    featured: false,
    content: '',
  },
  {
    id: 'kr-exam-001',
    title: 'TOPIK II高分突破集训营',
    slug: 'kr-exam-001',
    description: '聚焦TOPIK II考试核心考点与解题技巧，通过系统化的听力、阅读、写作训练，帮助学员在短期内提升考试成绩，冲刺5-6级。',
    shortDescription: 'TOPIK II集训营，冲刺高级证书',
    category: '资格考试',
    categorySlug: 'exam',
    zone: '二区',
    zoneLabel: '韩国区',
    imageSeq: 'kr-exam-001',
    author: '郑恩地',
    date: '2026-07-12',
    readTime: '20课时',
    rating: 4.7,
    students: 1268,
    price: '¥999',
    level: '高级',
    tags: ['TOPIK', '考试技巧', '冲刺班', '高级证书'],
    featured: false,
    content: '',
  },
  {
    id: 'jp-lang-002',
    title: '旅游日语速成：玩转日本',
    slug: 'jp-lang-002',
    description: '为计划赴日旅游的成人学习者量身定制，快速掌握旅行中必备的日语表达，包括交通、住宿、餐饮、购物、紧急情况等场景会话。',
    shortDescription: '10天速成旅游日语，轻松玩转日本',
    category: '语言课程',
    categorySlug: 'language',
    zone: '一区',
    zoneLabel: '日本区',
    imageSeq: 'jp-lang-002',
    author: '高桥美咲',
    date: '2026-07-25',
    readTime: '16课时',
    rating: 4.6,
    students: 2345,
    price: '¥599',
    level: '初级',
    tags: ['旅游日语', '场景会话', '短期速成', '日本旅行'],
    featured: false,
    content: '',
  },
  {
    id: 'kr-lang-002',
    title: '韩剧原声跟读训练营',
    slug: 'kr-lang-002',
    description: '精选热门韩剧经典片段，通过原声跟读训练提升韩语听说能力。课程涵盖日常口语、情感表达、职场对话等实用场景，让学习像追剧一样有趣。',
    shortDescription: '跟韩剧学地道韩语，听说能力飞跃',
    category: '语言课程',
    categorySlug: 'language',
    zone: '二区',
    zoneLabel: '韩国区',
    imageSeq: 'kr-lang-002',
    author: '宋慧乔',
    date: '2026-07-20',
    readTime: '20课时',
    rating: 4.9,
    students: 3567,
    price: '¥699',
    level: '中级',
    tags: ['韩剧跟读', '口语训练', '听力提升', '地道表达'],
    featured: false,
    content: '',
  },
];

export const getCoursesByCategory = (categorySlug: string): Course[] => {
  return courses.filter(c => c.categorySlug === categorySlug);
};

export const getCoursesByZone = (zone: '一区' | '二区'): Course[] => {
  return courses.filter(c => c.zone === zone);
};

export const getCourseById = (id: string): Course | undefined => {
  return courses.find(c => c.id === id);
};

export const getFeaturedCourses = (): Course[] => {
  return courses.filter(c => c.featured);
};

export const getRelatedCourses = (course: Course, limit: number = 4): Course[] => {
  return courses
    .filter(c => c.id !== course.id && (c.zone === course.zone || c.category === course.category))
    .slice(0, limit);
};